import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import "./app/globals.css";
import { initializeSentry } from "./sentry";

window.Buffer = Buffer;

initializeSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
